export default "__VITE_ASSET__DjdoXVPB__"